module.exports = __webpack_public_path__ + "img/27 Animation 2-squashed.d12811a1.jpg";